import { FC } from "react";
import SubmittedDocumentsSection from "../../IRB/IRBSubmission/CreateIRBSubmission/IRBSubmission/SubmittedDocumentsSection";
import FormDropdownField from "../../../common/Form/Dropdown/FormDropdownField";
import { FormikValues, useFormikContext } from "formik";
import { ALL_TYPES_OF_PVPD } from "../../../../constants";
import DropdownWithOther from "../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
import { DOCUMENTS, TYPE_OF_PV_PD } from "../../../../constants/forms";

const ECSubmissionPVPD: FC = (): JSX.Element => {
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();

  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
  };
  return (
    <>
      <DropdownWithOther
        label=" 2.1  Type of PV/PD"
        name={TYPE_OF_PV_PD}
        placeholder={"Type of PV/PD"}
        options={ALL_TYPES_OF_PVPD}
        disabled={false}
      />
      <SubmittedDocumentsSection
        fieldName={DOCUMENTS}
        labelText="2.2  Attachments"
      />
    </>
  );
};

export default ECSubmissionPVPD;
